import RSButton from "ds_legacy/components/RSButton";
import { PRIMARY_COLOR } from "ds_legacy/materials/colors";
import { useNavigate } from "react-router-dom";

export function RedirectButton({ label, url }: { label: string; url: string }) {
  const navigate = useNavigate();
  return (
    <RSButton
      color="white"
      id="error_redirect_to"
      loading="na"
      style={{ color: PRIMARY_COLOR }}
      variant="contained"
      onClick={() => navigate(url)}
    >
      {label}
    </RSButton>
  );
}
